/* eslint-disable react/jsx-props-no-spreading, react/prop-types */
import React from 'react';
import { element } from 'prop-types';
import { DynamicComponent } from './DynamicComponent';

export const withDynamicComponent = (WrappedComponent) => {

  // eslint-disable-next-line react/prop-types
  const Component = ({
    children, dynamic, ...props
  }) => {
    // eslint-disable-next-line react/prop-types
    if (!dynamic) {
      return <WrappedComponent {...props}>{children}</WrappedComponent>;
    }
    let dynamicProps = {};
    if (typeof dynamic === 'object') {
      dynamicProps = { ...dynamic };
    }
    return (
      <DynamicComponent {...dynamicProps}>
        <WrappedComponent {...props}>
          {children}
        </WrappedComponent>
      </DynamicComponent>
    );
  };

  Component.dataModel = WrappedComponent?.dataModel || {};

  return Component;
};

withDynamicComponent.propTypes = {
  WrappedComponent: element.isRequired,
};
